import { breakpoints } from 'styles/breakpoints.styles';
import { SubPageBanner, SubPageNav, SubPageTop } from 'styles/subPage.styles';
import noticeBanner from 'assets/img/notice/banner.png';
import noticeBannerMobile from 'assets/img/notice/banner_mobile.png';
import { NavLink, Outlet } from 'react-router-dom';
import ContactBanner from 'components/ContactBanner';

const Guide = () => {
  return (
    <>
      <SubPageTop>
        <SubPageBanner>
          <picture>
            <source media={breakpoints.mobile} srcSet={noticeBannerMobile} />
            <img src={noticeBanner} alt='매장 운영 가이드' />
          </picture>

          <div className='banner__content'>
            <small>Store Operations</small>
            <p>매장 운영 가이드</p>
          </div>
        </SubPageBanner>

        <SubPageNav>
          <ul>
            <li>
              <NavLink to='/guide' end>
                전체 가이드
              </NavLink>
            </li>
            <li>
              <NavLink to='/faq'>자주 묻는 질문</NavLink>
            </li>
          </ul>
        </SubPageNav>
      </SubPageTop>

      <Outlet />

      <ContactBanner type='blue' />
    </>
  );
};

export default Guide;
